(function importImagesProcessModuleDefinition() {

    'use strict';

    angular.module('BackgroundTask', ['ui.router', 'Config', 'Entities', 'ClickOnce'])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function backgroundTaskConfig(config, $stateProvider, loginProvider) {

                $stateProvider.state('background-task-home', {
                    url: "/BackgroundTask/Home",
                    templateUrl: config.resourceUrl('/views/background-task/home.html'),
                    controller: 'BackgroundTaskController',
                    authorize: true,
                    roles: loginProvider.roleCondition('BACKGROUND TASK READ')
                });

              
            }
        ]);
})();